import api from "../coreapiAxios";

// 请求分类
export const apiGetCategory = (params) => api.post(`/object-query`, params);

// 搜索
export const apiSearchVal = (objectAPIName, params) =>
  api.get(`/search/${objectAPIName}`, { params });
